var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8077 2.25912C15.2986 3.07785 13.6182 4.54615 11.5743 5.97504C7.85823 8.57248 2.61228 11.4516 2.04969 10.6485C1.48709 9.84616 5.99031 5.90852 9.7064 3.31107C11.7487 1.88301 13.7062 0.807237 14.6513 0.609329C15.4245 0.447553 15.8036 0.494361 16.0578 0.855688C16.3111 1.21702 16.2248 1.58902 15.8086 2.25829L15.8077 2.25912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50388 8.4879L0.546967 7.72994L0 8.11179L2.40583 10.3372L2.46505 10.4218L3.73665 13.4397L4.28361 13.057L4.58054 10.026L3.50388 8.4879Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6103 2.79043L1.78484 0L1.12601 0.460692L1.78402 0.690627L7.62546 4.87791L10.6103 2.79043Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.373 5.30494L11.9814 14.5393L11.3226 15L11.3317 14.3036L9.38809 7.3916L12.373 5.30494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.3ef31d0611abb87a0e8dde84b2fc9012.svg";
export { ForwardRef as ReactComponent };